(function () {
    'use strict';

    angular
        .module('app')
        .factory('DataService', DataService);

    DataService.$inject = ['$http', '$q', 'UrlService'];

    function DataService($http, $q, UrlService) {
        var service = function (resourceUrl) {
            return {
                query: query,
                get: get,
                remove: remove,
                save: save,
                convertQueryParams: convertQueryParams
            };

            /**
             * GET from the base resource URL, typically to fetch a list of resources for the given query.
             *
             * @param {string|Object} queryParams - If this is an object, it's converted into a query string. If it's a string, it's used as-is.
             */
            function query(queryParams) {
                var url = UrlService.getWebAPIUrl() + '/' + resourceUrl + '/';

                if (angular.isString(queryParams)) {
                    url += queryParams;
                } else if (angular.isObject(queryParams)) {
                    url += convertQueryParams(queryParams);
                }

                return $http.get(url)
                    .then(function (response) {
                        return response.data;
                    }, function (response) {
                        return $q.reject(response);
                    });
            }

            /**
             * GET the resource with the specified id.
             */
            function get(id) {
                return $http.get(UrlService.getWebAPIUrl() + '/' + resourceUrl + '/' + id)
                    .then(function (response) {
                        return response.data;
                    }, function (response) {
                        return $q.reject(response);
                    });
            }

            /**
             * DELETE the resource with the specified id.
             */
            function remove(id) {
                return $http.delete(UrlService.getWebAPIUrl() + '/' + resourceUrl + '/' + id)
                    .then(function (response) {
                        // OK
                    }, function (response) {
                        return $q.reject(response);
                    });
            }

            /**
             * POST a new resource, or PUT to update an existing one.
             *
             * If the data provided has a non-zero id or Id property, an existing resource will be updated.
             * Otherwise, a new resource will be created.
             *
             * @param {Object} data - The data to save.
             */
            function save(data) {
                if (data.Id || data.id) {
                    var id = data.Id ? data.Id : data.id;
                    return $http.put(UrlService.getWebAPIUrl() + '/' + resourceUrl + '/' + id, data)
                        .then(function (response) {
                            return response.data;
                        }, function (response) {
                            return $q.reject(response);
                        });
                } else {
                    return $http.post(UrlService.getWebAPIUrl() + '/' + resourceUrl + '/', data)
                        .then(function (response) {
                            return response.data;
                        }, function (response) {
                            return $q.reject(response);
                        });
                }
            }

            function convertQueryParams(queryParams) {
                var parameterString = '';

                if (angular.isDefined(queryParams) && queryParams !== null) {
                    for (var queryProperty in queryParams) {
                        if (queryParams.hasOwnProperty(queryProperty) && angular.isDefined(queryParams[queryProperty]) && queryParams[queryProperty] !== null) {
                            parameterString += parameterString.length > 0 ? '&' : '?';
                            if (angular.isArray(queryParams[queryProperty])) {
                                parameterString += convertQueryParamArray(queryProperty, queryParams[queryProperty]);
                            } else {
                                parameterString += queryProperty + '=' + queryParams[queryProperty];
                            }
                        }
                    }
                }

                return parameterString;
            }

            /**
             * Converts the parameter of type Array into a query string
             *
             * E.g. propertyName = 'example', paramArray = [1,2,3] would result in the string 'example=1&example=2&example=3' being returned
             *
             * @param {string} data - The parameter string part for the supplied parameter
             */
            function convertQueryParamArray(propertyName, paramArray) {
                var result = '';
                var firstProperty = true;
                angular.forEach(paramArray, function (value) {
                    if (!firstProperty) {
                        result += '&';
                    } else {
                        firstProperty = false;
                    }
                    result += propertyName + '=' + value;
                });

                return result;
            }
        };

        return service;
    }
})();